export const userConst = {
    AUTH_STATUS_PENDING: 'AUTH_STATUS_PENDING',
    AUTH_STATUS_UNAUTHORIZED: 'AUTH_STATUS_UNAUTHORIZED',
    AUTH_STATUS_AUTHORIZED: 'AUTH_STATUS_AUTHORIZED',
    AUTH_STATUS_LOGGED_OUT:'AUTH_STATUS_LOGGED_OUT',
    ACCESS_DENIED: 'ACCESS_DENIED',
};
